import Controller from "./heatmap.controller";
import template from "./heatmap.html";

const heatmap = {
  template,
  controller: Controller,
  bindings: {
    data: "<",
  },
};

export default heatmap;



// WEBPACK FOOTER //
// ./src/components/heatmap/heatmap.component.js